import { Field, ErrorMessage } from "formik";
import React from "react";
import "../../assets/css/idp-school-new.css";

function SingleSelect({ questionName, name, options, isMandatory }) {
  return (
    <>
      {!!questionName && (
        <h2 className="card_medicine_heading">
          {questionName}
          {isMandatory && <span style={{ color: "red" }}> *</span>}
        </h2>
      )}

      <Field as="select" name={name} className="basic-single styled-select">
        <option value="">Select an option</option>
        {options.map((option, i) => (
          <option key={i} value={option.id}>
            {option.name}
          </option>
        ))}
      </Field>

      <ErrorMessage name={name} component="div" className="error" />
    </>
  );
}

export default SingleSelect;
